import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about.component';
import { P0Component } from './p0/p0.component';
import { P1Component } from './p1/p1.component';
import { P2Component } from './p2/p2.component';
import { P3Component } from './p3/p3.component';
import { P4Component } from './p4/p4.component';

const routes: Routes = [
  {
    component: AboutComponent,
    path: '',
    children: [
      { path: 'p0', component: P0Component },
      { path: 'p1', component: P1Component },
      { path: 'p2', component: P2Component },
      { path: 'p3', component: P3Component },
      { path: 'p4', component: P4Component },
      { path: '', component: P0Component }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AboutRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/tw/about/about-routing.module.ts